module.exports = __webpack_public_path__ + "static/img/1_0020.ac7e8dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0020.jpg
// module id = 3QN1
// module chunks = 0